module.exports = __webpack_public_path__ + "sunsemweb/img/produce.1050fe21.jpg";